export const exterior_view08ImageOptions = {
  angle: 'exterior_view08',
  staticOptions: {
    HullColour: 1,
    HullTreatment: 1,
    BowSpritRailing: 1,
    BowSpritLadder: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    MastAndBoom: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/exterior_view08.js